import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { onScrollChange } from '@analytics/scroll-utils';
import { track, onAnalyticsUnload } from '../analytics';
import { WebsiteEvents } from '../constants/events';
var defaultScrollOptions = {
  thresholds: [10, 25, 50, 75, 90]
};

var handler = function handler(payload) {
  track(WebsiteEvents.SCROLL, {
    scroll_depth: payload.trigger
  });
};
/**
 * This tracker is used to track scroll events.
 * It's dispatched when the user scrolls the page to the certain percentage of the page height.
 * The percentage is configurable via options.thresholds.
 */


export var scrollEventTracker = function scrollEventTracker(options) {
  options = _objectSpread(_objectSpread({}, defaultScrollOptions), options);
  var handlers = {};
  options.thresholds.forEach(function (percent) {
    handlers[percent] = handler;
  });
  var removeScrollListener = onScrollChange(handlers);
  onAnalyticsUnload(removeScrollListener);
};